<template>
  <li class="nav-item general-search-navbar-wrapper">
    <!-- Search Toggle Icon (all breakpoints) -->
    <a
      href="javascript:void(0)"
      class="nav-link general-search-toggle"
      :class="{ 'is-active': isToggleActive }"
      @click="toggleSearch"
    >
      <feather-icon
        badge-classes="bg-danger"
        class="search-icon"
        icon="SearchIcon"
        size="21"
      />
    </a>

    <!-- Desktop Popover -->
    <transition name="fade-slide">
      <div
        v-if="isDesktopPopoverOpen"
        class="global-search-popover"
        @click.stop="closeTypeSelector"
      >
        <div class="popover-header">
          <h4 class="popover-title">
            Global Search
          </h4>
          <feather-icon
            icon="XIcon"
            size="16"
            class="popover-close-icon"
            @click="closeDesktopPopover"
          />
        </div>

        <div
          class="popover-search-row"
          :class="{ 'has-error': errorMessage }"
        >
          <div
            class="popover-type-select"
            @click.stop="toggleTypeSelector"
          >
            <span class="popover-type-text">{{ searchTypeLabel }}</span>
            <feather-icon
              icon="ChevronDownIcon"
              size="14"
              class="chevron-icon"
              :class="{ 'chevron-rotated': isTypeSelectorOpen }"
            />

            <transition name="fade-slide">
              <div
                v-if="isTypeSelectorOpen"
                class="search-type-dropdown-options popover-type-dropdown"
              >
                <div
                  class="dropdown-option"
                  :class="{ active: searchType === 'waybill' }"
                  @click.stop="selectSearchType('waybill')"
                >
                  Waybill
                </div>
                <div
                  class="dropdown-option"
                  :class="{ active: searchType === 'city' }"
                  @click.stop="selectSearchType('city')"
                >
                  City
                </div>
              </div>
            </transition>
          </div>

          <div class="popover-input-wrapper">
            <input
              v-if="searchType === 'waybill'"
              key="waybill-input"
              ref="waybillInput"
              v-model="waybillNumber"
              type="text"
              placeholder="Enter Waybill Number"
              class="popover-search-input"
              autocomplete="off"
              @keyup.enter="triggerSearch"
              @input="clearError"
            >
            <input
              v-else
              key="city-input"
              ref="cityInput"
              v-model="inputName"
              type="text"
              placeholder="Enter City Name"
              class="popover-search-input"
              autocomplete="off"
              @keyup.enter="triggerSearch"
              @input="clearError"
            >
            <feather-icon
              v-if="canSearch"
              icon="XIcon"
              size="14"
              class="clear-icon popover-clear"
              @click.stop="clearInput"
            />
          </div>

          <button
            type="button"
            class="popover-search-btn"
            :disabled="!canSearch"
            @click="triggerSearch"
          >
            <feather-icon
              icon="SearchIcon"
              size="18"
            />
          </button>
        </div>

        <span
          v-if="errorMessage"
          class="popover-error-text"
        >
          {{ errorMessage }}
        </span>
      </div>
    </transition>

    <view-city-result-modal ref="viewCityResultModal" />
    <view-order-modal ref="viewOrderModal" />
  </li>
</template>

<script>
import ViewOrderModal from '@/components/orders/ViewOrderModal.vue'
import viewCityResultModal from '@/components/GeneralSearch/viewCityResultModal.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const OrderRepository = RepositoryFactory.get('order')
const genarelSearchRepository = RepositoryFactory.get('genarelSearch')
const DESKTOP_BREAKPOINT = 992

export default {
  components: {
    ViewOrderModal,
    viewCityResultModal,
  },
  data() {
    return {
      searchType: 'waybill',
      isTypeSelectorOpen: false,
      isDesktopPopoverOpen: false,
      selectedDemarcation: '',
      waybillNumber: '',
      disabled: true,
      orderId: '',
      inputName: '',
      errorMessage: '',
    }
  },
  computed: {
    searchTypeLabel() {
      return this.searchType === 'waybill' ? 'Waybill' : 'City'
    },
    canSearch() {
      const value = this.searchType === 'waybill' ? this.waybillNumber : this.inputName
      return !!(value && value.trim())
    },
    isMobileSearchOpen() {
      return this.$store.state.app.isGeneralSearchOpen
    },
    isToggleActive() {
      return this.isDesktopPopoverOpen || this.isMobileSearchOpen
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    isDesktopViewport() {
      return window.innerWidth >= DESKTOP_BREAKPOINT
    },
    clearError() {
      this.errorMessage = ''
    },
    clearInput() {
      if (this.searchType === 'waybill') {
        this.waybillNumber = ''
        this.$nextTick(() => {
          if (this.$refs.waybillInput) this.$refs.waybillInput.focus()
        })
      } else {
        this.inputName = ''
        this.$nextTick(() => {
          if (this.$refs.cityInput) this.$refs.cityInput.focus()
        })
      }
      this.errorMessage = ''
    },
    toggleTypeSelector() {
      this.isTypeSelectorOpen = !this.isTypeSelectorOpen
    },
    closeTypeSelector() {
      this.isTypeSelectorOpen = false
    },
    handleOutsideClick() {
      this.isTypeSelectorOpen = false
      if (this.isDesktopPopoverOpen) {
        this.closeDesktopPopover()
      }
    },
    handleResize() {
      if (this.isDesktopViewport()) {
        if (this.isMobileSearchOpen) {
          this.$store.commit('app/TOGGLE_GENERAL_SEARCH', false)
        }
      } else if (this.isDesktopPopoverOpen) {
        this.closeDesktopPopover()
      }
    },
    selectSearchType(type) {
      this.searchType = type
      this.isTypeSelectorOpen = false
      this.errorMessage = ''
      if (type === 'city') {
        this.selectedDemarcation = 'City'
      } else {
        this.selectedDemarcation = ''
      }
      this.orderId = ''
      this.disabled = true
      this.$nextTick(() => {
        if (type === 'waybill' && this.$refs.waybillInput) {
          this.$refs.waybillInput.focus()
        } else if (type === 'city' && this.$refs.cityInput) {
          this.$refs.cityInput.focus()
        }
      })
    },
    async onClickSearchWayBill() {
      if (!this.waybillNumber) {
        this.errorMessage = 'Please enter waybill number'
        return
      }
      this.errorMessage = ''
      try {
        const { data } = (await OrderRepository.getOrderDetailsByWaybill(this.waybillNumber)).data
        if (!data || !data.id) {
          this.errorMessage = 'Waybill not found'
          return
        }
        this.orderId = data.id
        this.onClickViewOrder()
      } catch (e) {
        this.disabled = false
        if (e.response && e.response.status === 404) {
          this.errorMessage = 'Waybill not found'
        } else if (e.response && e.response.data && e.response.data.message) {
          if (typeof e.response.data.message === 'string') {
            this.errorMessage = e.response.data.message
          } else {
            const msgs = Object.values(e.response.data.message)
            this.errorMessage = msgs.length ? msgs[0].error || msgs[0] : 'Error searching waybill'
          }
        } else if (e.response && e.response.data && e.response.data.errors) {
          const errors = Object.values(e.response.data.errors)
          this.errorMessage = errors.length ? errors[0][0] || errors[0] : 'Error searching waybill'
        } else {
          this.errorMessage = 'Waybill not found'
        }
      }
    },
    onClickViewOrder() {
      this.$refs.viewOrderModal.openModal(this.orderId)
      this.clearFormAndValidation()
      this.closeDesktopPopover()
    },
    async onClickSearchDemarcation() {
      if (!this.inputName) {
        this.errorMessage = 'Please enter city name'
        return
      }
      this.errorMessage = ''
      try {
        const { data } = (await genarelSearchRepository.cityListByName(this.inputName)).data
        if (!data || data.length === 0) {
          this.errorMessage = 'City not found'
          return
        }
        this.$refs.viewCityResultModal.openModal(this.inputName, data)
        this.clearFormAndValidation()
        this.closeDesktopPopover()
      } catch (e) {
        this.errorMessage = 'City not found'
      }
    },
    triggerSearch() {
      if (!this.canSearch) return
      if (this.searchType === 'waybill') {
        this.onClickSearchWayBill()
      } else {
        this.onClickSearchDemarcation()
      }
    },
    clearFormAndValidation() {
      this.waybillNumber = ''
      this.selectedDemarcation = ''
      this.inputName = ''
      this.disabled = true
      this.orderId = ''
      this.searchType = 'waybill'
      this.isTypeSelectorOpen = false
      this.errorMessage = ''
    },
    openDesktopPopover() {
      this.isDesktopPopoverOpen = true
      this.clearFormAndValidation()
      this.$nextTick(() => {
        if (this.$refs.waybillInput) {
          this.$refs.waybillInput.focus()
        }
      })
    },
    closeDesktopPopover() {
      this.isDesktopPopoverOpen = false
      this.isTypeSelectorOpen = false
      this.errorMessage = ''
    },
    toggleSearch(event) {
      if (event) {
        event.stopPropagation()
      }
      if (this.isDesktopViewport()) {
        if (this.isDesktopPopoverOpen) {
          this.closeDesktopPopover()
        } else {
          this.openDesktopPopover()
        }
      } else {
        this.$store.commit('app/TOGGLE_GENERAL_SEARCH')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/general-search.scss';
</style>
